import { render, staticRenderFns } from "./LoginRegisterButton.vue?vue&type=template&id=2097b1e5"
import script from "./LoginRegisterButton.vue?vue&type=script&lang=ts"
export * from "./LoginRegisterButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports